import React from 'react'
import { CalendarClock } from 'lucide-react'

interface ISuggestedTime {
  date: string
  time: string
  dateTime: Date
}

interface ISuggestedTimesProps {
  suggestedTimes: ISuggestedTime[]
  isLoading: boolean
  onTimeSelect: (suggestion: ISuggestedTime) => void
}

export const SuggestedTimes: React.FC<ISuggestedTimesProps> = ({
  suggestedTimes,
  isLoading,
  onTimeSelect,
}) => {
  return (
    <div className="mb-5">
      <label className="block text-sm font-medium text-primary-text mb-2">
        Suggested Times (Everyone is free)
      </label>
      <div className="bg-primary-brandLight bg-opacity-30 border border-primary-outline rounded-lg p-3">
        {isLoading ? (
          <div className="flex items-center justify-center py-4">
            <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-primary"></div>
            <span className="ml-2 text-sm text-primary-text">Finding available times...</span>
          </div>
        ) : suggestedTimes.length > 0 ? (
          <div className="space-y-2">
            {suggestedTimes.map((suggestion, index) => (
              <button
                key={index}
                onClick={() => onTimeSelect(suggestion)}
                className="w-full flex items-center justify-between px-3 py-2 bg-white hover:bg-primary-brandLight border border-primary-outline rounded-md transition-colors text-left group"
              >
                <div className="flex items-center gap-2">
                  <CalendarClock className="w-4 h-4 text-primary flex-shrink-0" />
                  <span className="text-sm font-medium text-primary-text">{suggestion.date}</span>
                  <span className="text-sm text-silver-light">•</span>
                  <span className="text-sm text-primary-text">{suggestion.time}</span>
                </div>
                <svg
                  className="w-4 h-4 text-silver-light group-hover:text-primary transition-colors"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 5l7 7-7 7"
                  />
                </svg>
              </button>
            ))}
          </div>
        ) : (
          <div className="flex items-center justify-center py-4">
            <span className="text-sm text-silver-light">No available times found</span>
          </div>
        )}
      </div>
    </div>
  )
}
